<template>
  <div
    id="data-list-list-view"
    class="data-list-container vs-con-loading__container"
    style="min-height: 80vh">
    <vx-card>
      <template slot="no-body">
        <div class="p-2">
          <!--<vs-switch color="success" v-model="active_geofence">-->
          <!--<span slot="on">Geofence On </span>-->
          <!--<span slot="off">Geofence Off </span>-->
          <!--</vs-switch>-->
          <div class="vx-row">
            <vs-col vs-w="4">
              <VueCtkDateTimePicker
                no-button-now
                label="Select Start Date"
                format="YYYY-MM-DD HH:mm"
                :min-date="minStart"
                :max-date="maxStart"
                v-model="dateStart" />
            </vs-col>
            <vs-col vs-w="4">
              <VueCtkDateTimePicker
                :disabled="dateStart == null"
                no-button-now
                label="Select End Date"
                format="YYYY-MM-DD HH:mm"
                :min-date="dateStart"
                :max-date="maxEnd"
                v-model="dateEnd" />
            </vs-col>
            <vs-col vs-w="4">
              <vs-button
                type="gradient"
                class="shadow btn-load-1 vs-con-loading__container"
                color="#d23030"
                gradient-color-secondary="#f89595"
                @click="
                  getData(id, { start_date: dateStart, end_date: dateEnd })
                "
                >Filter
              </vs-button>
              <!-- <vs-button
                type="gradient"
                class="shadow btn-download-1 vs-con-loading__container ml-3"
                color="#922e2e"
                gradient-color-secondary="#ff4e4e"
                @click="download_data()"
                >Download Data
              </vs-button> -->
            </vs-col>
          </div>
        </div>
        <div id="loading-container" class="w-full"></div>

        <div id="table">
          <vs-table ref="table" :max-items="itemsPerPage" :data="data">
            <template slot="thead">
              <vs-th>No Ritase</vs-th>
              <vs-th>Driver</vs-th>
              <vs-th>Start Time</vs-th>
              <vs-th>End Time</vs-th>
              <vs-th>Duration</vs-th>
              <vs-th>Distance</vs-th>
              <vs-th>Action</vs-th>
            </template>
            <template slot-scope="{ data }">
              <tbody id="isi_table">
                <vs-tr
                  class="cursor-default"
                  :data="tr"
                  :key="indextr"
                  v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].no_ritase">
                    <p class="product-name font-medium">{{ tr.no_ritase }}</p>
                  </vs-td>
                  <vs-td :data="data[indextr].driver">
                    <p class="product-name font-medium">{{ tr.driver }}</p>
                  </vs-td>
                  <vs-td :data="data[indextr].start_time">
                    <p class="product-name font-medium">{{ tr.start_time }}</p>
                  </vs-td>
                  <vs-td :data="data[indextr].end_time">
                    <p class="product-name font-medium">{{ tr.end_time }}</p>
                  </vs-td>
                  <vs-td :data="data[indextr].duration">
                    <p class="product-name font-medium">
                      {{ getSimpleDurationV2(tr.duration) }}
                    </p>
                  </vs-td>
                  <vs-td :data="data[indextr].distance">
                    <p class="product-name font-medium">
                      {{ parseInt(tr.distance / 1000) }} KM
                    </p>
                  </vs-td>
                  <vs-td>
                    <vs-button
                      radius
                      color="danger"
                      type="border"
                      icon="play_arrow"
                      @click="goToTimeline(tr)"></vs-button>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </div>

        <vs-divider style="margin: 0" />
      </template>
    </vx-card>

    <!--<vs-button class="mr-3 mb-2" @click="submitForm" >Get Data</vs-button>-->
  </div>
</template>

<script>
import * as REPO from '../../repository/index'
import { gmapApi } from 'vue2-google-maps'
import * as moment from 'moment'
import XLSX from 'xlsx'
import RangeSlider from 'vue-range-slider'
import VueApexCharts from 'vue-apexcharts'
// import 'vue-range-slider/dist/vue-range-slider.css'

import InfoWindow from '../components/InfoWindow.vue'

const initialState = () => {
  return {
    isGraphVisible: false,
    series: [],
    chartOptions: {
      chart: {
        height: 350,
        type: 'area',
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'datetime',
        categories: [],
      },
      tooltip: {
        x: {
          format: 'dd/MM/yy HH:mm',
        },
      },
    },

    dataGroup: [],
    selectedData: {},
    disabledDates: {
      to: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDay() - 14
      ), // Disable all dates up to specific date
      from: new Date(), // Disable all dates after specific date
    },
    minStart: moment().subtract(3, 'months').format('YYYY-MM-DD HH:mm'),
    maxStart: moment().format('YYYY-MM-DD HH:mm'),

    response: [],
    infoBoxOpen: false,
    selectedLocation: null,
    directionsRenderer: '',
    location_list: [
      { lat: -6.167909, lng: 106.871585 },
      { lat: -6.170949, lng: 106.865867 },
      { lat: -6.17493, lng: 106.849967 },
      { lat: -6.152307, lng: 106.874697 },
      { lat: -6.149366, lng: 106.874697 },
    ],
    dateStart: null,
    overlay: true,
    kmStep: 0,
    baseSpeed: 8,
    zoomNow: 0,
    lastVertex: 1,
    maxEnd: null,
    dateEnd: null,
    id: '',
    tabIndex: 0,
    tabColor: 'danger',
    data: [],

    itemsPerPage: 15,
  }
}
export default {
  props: {
    license_plate: String,
    vehicle_category: String,
  },
  components: {
    RangeSlider,
    InfoWindow,
    VueApexCharts,
  },
  data: () => ({
    ...initialState(),
  }),
  computed: {
    google: gmapApi,
  },
  watch: {
    // dateStart(val) {
    //   this.dateEnd = null
    //   if (val != null) {
    //     //
    //     let tmp = moment(val).add(7, 'days').format('YYYY-MM-DD HH:mm')
    //     if (moment(tmp).isAfter(moment())) {
    //       this.maxEnd = moment().format('YYYY-MM-DD HH:mm')
    //     } else {
    //       this.maxEnd = tmp
    //     }
    //   }
    // },
  },
  created() {
    var self = this
  },
  beforeDestroy() {
    // REPO.unsubscribeVehicle(this.$route.params.id);
    //
  },
  methods: {
    goToTimeline(tr) {
      const date = moment(tr.start_time)

      const body = {
        date: date,
        id: tr.id,
      }
      this.$root.$emit('goToTimeline', body)
    },
    checkStatus(key, val) {
      let selected = JSON.parse(JSON.stringify(this.selectedLocation))
      //
      if (key in selected) {
        if (selected[key] == val) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    download_data() {
      var ProgressBar = require('progressbar.js')
      var bar = new ProgressBar.Line('#loading-container', {
        strokeWidth: 1,
        easing: 'easeInOut',
        duration: 1400,
        borderRadius: '10px',
        color: 'rgba(234, 84, 85, 1)',
        trailColor: '#eee',
        trailWidth: 1,
        svgStyle: { width: '100%', height: '100%', borderRadius: '10px' },
        text: {
          style: {
            color: '#999',
            position: 'absolute',
            right: '0',
            top: '30px',
            padding: 0,
            margin: 0,
            transform: null,
          },
          autoStyleContainer: false,
        },
        from: { color: '#FFEA82' },
        to: { color: '#ED6A5A' },
        step: (state, bar) => {
          bar.setText('Collecting Data ' + Math.round(bar.value() * 100) + ' %')
        },
      })

      bar.animate(0.0)
      this.loadingBtnStart('btn-download-1')
      REPO.getPlayback({
        start_date: this.dateStart,
        end_date: this.dateEnd,
        license_plate: this.license_plate,
      }).then(async (res) => {
        const tmp = res.data.data
        const temp = tmp.map((x, index) => {
          bar.animate(1.0)
          return {
            'License Plate': x.license_plate,
            Alert: x.event_name,
            Ignition: x.ignition == 0 ? 'OFF' : 'ON',
            Speed: x.speed + ' Km/h',
            Direction: x.direction + '°',
            Date: x.device_time,
            'Driver Name': x.driver_name ? x.driver_name : '-',
            'Driver Phone': x.driver_phone ? x.driver_phone : '-',
            Gmaps: 'Show Google Map',
            Streetview: 'Show Street View',
          }
        })

        const rows = temp
        const worksheet = XLSX.utils.json_to_sheet(rows)
        for (let i = 0; i < rows.length; i++) {
          worksheet[`I${i + 2}`] = {
            v: 'Show Google Map',
            t: 's',
            l: {
              Target: `https://www.google.com/maps/search/?api=1&query=${tmp[i].latitude},${tmp[i].longitude}`,
              Tooltip: 'Show Google Map',
            },
            s: {
              font: {
                color: { rgb: '0563C1' },
                underline: true,
              },
            },
          }
          worksheet[`J${i + 2}`] = {
            v: 'Show Street View',
            t: 's',
            l: {
              Target: `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${tmp[i].latitude},${tmp[i].longitude}`,
              Tooltip: 'Show Street View',
            },
            s: {
              font: {
                color: { rgb: '0563C1' },
                underline: true,
              },
            },
          }
        }
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dates')

        XLSX.writeFile(
          workbook,
          `periodic_track_${this.license_plate}_${moment().format(
            'YYYY-MM-DD_HHmm'
          )}.xlsx`,
          {
            compression: true,
          }
        )

        this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        this.$vs.loading.close('#isi_table > .con-vs-loading')
        this.loadingBtnStop('btn-download')
        this.load_done = true
        // destroy bar
        bar.destroy()
        this.loadingBtnStop('btn-download-1')
      })

      this.loadingBtnStop('btn-download-1')
    },
    async getAddress(latitude, longitude) {
      const body = {
        lat: latitude,
        lon: longitude,
      }
      let tmp = await REPO.getAddress(body)
      //
      return tmp.data.data
    },
    format_number(val) {
      if (val) {
        let tmp = Math.round(val)
        return tmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      } else {
        return val
      }
    },
    toIsoString(date) {
      var tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function (num) {
          return (num < 10 ? '0' : '') + num
        }

      return (
        date.getFullYear() +
        '-' +
        pad(date.getMonth() + 1) +
        '-' +
        pad(date.getDate()) +
        'T' +
        pad(date.getHours()) +
        ':' +
        pad(date.getMinutes()) +
        ':' +
        pad(date.getSeconds()) +
        '.000Z'
        // dif +
        // pad(Math.floor(Math.abs(tzo) / 60)) +
        // ':' +
        // pad(Math.abs(tzo) % 60)
      )
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    getData(id, body) {
      // this.loadingBtnStart('btn-load-1')
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      // REPO.getRitase(id, body).then((res) => {
      //
      // })
      REPO.getRitase(id, body)
        .then((res) => {
          const tmp = res.data.data.data
          this.data = tmp.map((x, index) => {
            return {
              id: x._id,
              no_ritase: index + 1,
              driver: x.drive_name ? x.drive_name : '',
              start_time: x.departure_date_time,
              end_time: x.arrival_date_time,
              duration: x.duration,
              distance: x.distance_travel,
            }
          })
          //
        })
        .finally(() => {
          // this.loadingBtnStop('btn-load-1')
          this.$vs.loading.close('#isi_table > .con-vs-loading')
        })
      // this.data = [
      //   {
      //     id: 1,
      //     no_ritase: 1,
      //     driver: 'Susanto',
      //     start_time: '2024-11-04 08:09:00',
      //     end_time: '2024-11-04 08:09:00',
      //     duration: '3h 2m',
      //     distance: '14,23 km',
      //   },
      // ]
    },
  },

  mounted() {
    let self = this
    // set dateStart to today 00:00 and dateEnd to today now
    // this.dateStart = moment().subtract(3, 'days').format('YYYY-MM-DD HH:mm')
    this.dateStart = moment().format('YYYY-MM-DD') + ' 00:00'
    this.dateEnd = moment().format('YYYY-MM-DD HH:mm')
    this.id = this.$route.params.id
    this.getData(this.id, {
      start_date: this.dateStart,
      end_date: this.dateEnd,
    })
  },
}
</script>

<style lang="scss">
$rail-fill-color: #ff1111;

@import '~vue-range-slider/dist/vue-range-slider.scss';

.datetimepicker > .flex {
  display: none !important;
}

.visible > .flex {
  display: block !important;
  left: 0;
}

.date-popup > .vs-popup > .vs-popup--content {
  overflow: visible;
}

.con-slot-tabs {
  height: calc(100% - 38px);

  .con-tab {
    height: 100%;
  }
}
</style>

<style lang="scss" scoped>
.control-place {
  position: absolute;
  z-index: 2;
  bottom: 3px;
  // bottom: -10px;
  // left: 50%;
  // transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  width: calc(100% - 60px);

  .controls {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
}

.control-side {
  position: absolute;
  z-index: 3;
  bottom: 150px;
  right: 10px;
  transform: translateY(50%);
  display: flex;
  flex-direction: column;

  .controls {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
}

.startendmarker {
  background-color: black;
  border-radius: 5px;
  padding: 5px;
  color: black;
  // font-weight: bold;
  // font-size: 12px;
}

.tooltip-top {
  position: absolute;
  top: -30px;
  left: -10px;
  background: #ff1111;
  color: white;
  padding: 5px;
  border-radius: 5px;
  font-size: 12px;
}

.control-btn {
  background: linear-gradient(30deg, #d23030 0%, #f89595 100%);
  border-radius: 50%;
  margin: 10px;
  font-size: 12px;
  color: white;
  width: 30px;
  font-weight: bold;
  cursor: pointer;
  height: 30px;
  padding-left: 8px;
  padding-top: 7px;
  box-shadow: 2px 3px 4px dimgrey;
}

.buletan {
  float: left;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-top: 3px;
  margin-right: 6px;
}

.biru {
  background: blue;
}

.merah {
  background: red;
}

.item {
  background: black;
}
.ijo {
  background: green;
}

input {
  border: 2px solid #1489da;
}

.datetimepicker > .flex {
  display: none !important;
}

.visible > .flex {
  display: flex !important;
}

.date-popup > .vs-popup > .vs-popup--content {
  overflow: visible;
}

.heights {
  width: 100%;
  height: calc(100vh - 16.5rem);
}

.legenda {
  box-shadow: -2px 2px 4px #97b5ca;
  padding: 5px;
  right: 0;
  font-size: 12px;
  width: 150px;
  position: absolute;
  z-index: 1;
  background: white;
  border-radius: 7px;
}

.grab:hover {
  cursor: n-resize;
}

// div.gmnoprint {
//   z-index: 6 !important;
// }
</style>
